import React, { useEffect, useState, useRef } from 'react';
interface FadeInProps {
  children: ReactNode;
  delay?: number;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
  className?: string;
}
export function FadeIn({
  children,
  delay = 0,
  direction = 'up',
  className = ''
}: FadeInProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  // Check reduced motion preference
  const prefersReducedMotion = typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  useEffect(() => {
    if (prefersReducedMotion) {
      setIsVisible(true);
      return;
    }
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.unobserve(el);
      }
    }, {
      rootMargin: '-40px',
      threshold: 0.01
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [prefersReducedMotion]);
  const directionStyles: Record<string, string> = {
    up: 'translate-y-[24px]',
    down: 'translate-y-[-24px]',
    left: 'translate-x-[24px]',
    right: 'translate-x-[-24px]',
    none: ''
  };
  return <div ref={ref} className={`transition-all duration-500 ease-out ${isVisible ? 'opacity-100 translate-x-0 translate-y-0' : `opacity-0 ${directionStyles[direction]}`} ${className}`} style={{
    transitionDelay: isVisible ? `${delay * 1000}ms` : '0ms'
  }} data-id="element-553">
      {children}
    </div>;
}